<template>
  <div class="colorfule-date-picker">
    <el-time-picker
      v-model="values"
      ref="datePicker"
      prefix-icon="null"
      :readonly="readonly"
      :disabled="disabled"
      :type="datePickerType"
      :clearable="clearable"
      :value-format="formatValue"
      :pickerOptions="pickerOptions"
      :placeholder="placeholderText"
      format="HH:mm:ss"
    />
    <svg-icon
      v-if="!readonly"
      icon-class="date_time"
      @click="handleClickIcon"
      class="color-primary right-icon"
    />
  </div>
</template>

<script>
import { TimePicker } from 'element-ui'
export default {
  name: 'time-picker',
  components: {
    'el-time-picker': TimePicker
  },

  props: {
    value: [String, Date, Number],
    time: {
      type: Boolean,
      default: false,
      comment: '是否显示秒'
    },
    readonly: {
      type: Boolean,
      default: false,
      comment: '是否完全只读'
    },
    disabled: {
      type: Boolean,
      default: false,
      comment: '是否禁用'
    },
    clearable: {
      type: Boolean,
      default: false,
      comment: '是否可以一键清除'
    },
    placeholder: {
      type: String,
      default: '请选择时间',
      comment: 'placeholder提示文本'
    },
    grayColor: {
      type: String,
      default: '时间置灰',
      comment: 'placeholder提示文本'
    },
    pickerOptions: Object
  },

  computed: {
    values: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val || '')
      }
    },
    datePickerType() {
      return this.time ? 'datetime' : 'date'
    },
    formatValue() {
      return this.time ? 'HH:mm:ss' : 'HH:mm:ss'
    },
    placeholderText() {
      return this.readonly ? '' : this.placeholder
    }
  },

  methods: {
    handleClickIcon() {
      this.$refs.datePicker.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../DatePicker/index.scss';
</style>
